import { Box,Container, Typography } from "@mui/material";
import React from "react";
import counselling from "../../images/couns.png";

const styles = {
  parenBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px",
  },
  leftBox: {
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
    flexDirection: "column",
    gap: 3,
    flexWrap:"wrap"
  },
  rightBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroTitle: {
    fontFamily: "poppins",
    fontWeight: "bold",
    lineHeight: 1.5,
    opacity: 0.7,
  },
  heroSubtitle: {
    fontFamily: "poppins",
    fontWeight: 600,
    opacity: 0.7,
  },
  button: {
    px: "10px",
    py: "5px",
    fontFamily: "poppins",
    fontSize: "14px",
    textTransform: "none",
    backgroundColor: "#141414FF",
    color: "#ffffff",
  },
};

const CounsHero = () => {

  return (
    <Container maxWidth="lg">
      <Box sx={{ ...styles.parenBox }}>
        <Box sx={{ ...styles.leftBox }}>
          <Typography
            variant="h4"
            textAlign={"start"}
            sx={{ ...styles.heroTitle }}
          >
            Personal Counselling
          </Typography>
          <Typography
            variant="body1"
            textAlign="start"
            sx={{ ...styles.heroSubtitle }}
          >
            In counseling we provide personal attention by listening to your
            problem and to draw the best solution to whatever problems you are
            going through. The solutions we provide are a mixture of psychology
            and meditation. If you do not want any solutions but you need a
            platform where you want somebody to just hear you out, then we are
            all ears. We only want you to be free of all the suffering and our
            only aim is to build you a better relationship with yourself and
            your surroundings. If you require solutions then we can only guide
            you to the necessary solution only by first listening to the
            problems you are going through.
          </Typography>
          
        </Box>

        <Box sx={{ ...styles.rightBox }}>
          <Box
            component="img"
            src={counselling}
            sx={{ width: "500px", heigh: "500px", borderRadius: "50px" }}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default CounsHero;
